// extracted by mini-css-extract-plugin
export default {"box":"box_box__A46RO","mainDiv":"box_mainDiv__D7XUL","imgBlock":"box_imgBlock__AB-in","popupTheme":"box_popupTheme__3PkEx"};